module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "chaptitle"
  }, [_c('big', [_vm._v("I")]), _vm._v("LLUSTRATIONS")], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#img15_1"
    }
  }, [_vm._v("Brigadier General Simon Bolivar Buckner")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#img17_1"
    }
  }, [_vm._v("Federal troops of the Army of the Ohio on the north bank of the Green River")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#img20_1"
    }
  }, [_vm._v("General Albert Sidney Johnston")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#img26_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brigadier General Ulysses S. Grant")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#img31_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colonel Roger Weightman Hanson")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#img33_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The surrender flag appears on the parapet of Fort Donelson")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#img45_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major General Don Carlos Buell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#img48_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain John Hunt Morgan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#img55_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The covered bridge over the Dix River")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#img56_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Burnt Tavern, Bryantsville, Kentucky")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#img58_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thomas Henry Hines")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#img60_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Main Street, Lexington, Kentucky, 1860")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#img63_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keene Springs Tavern and Hotel, Jessamine County, Kentucky")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#img65_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A rarely published carte de visite photograph of General Abraham Buford")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#img69_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The covered bridge over the South Fork of the Licking River at Cynthiana, Kentucky")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#img70_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Woodcut of the Battle of Cynthiana, Kentucky, July 17, 1862")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#img72_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morgan's command enters Paris, Kentucky, July 18, 1862")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#img79_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colonel John Hunt Morgan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#img82_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain John B. Castleman")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#img85_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major General Edmund Kirby Smith")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#img88_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major William Campbell Preston Breckinridge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#img88_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Braxton Bragg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#img89_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brigadier General Humphrey Marshall")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#img94_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Henry Clay Home as it would have looked in 1862")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#img99_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A company of Indiana volunteers in the Army of the Ohio")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#img107_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major General John C. Breckinridge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#img108_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major General William S. Rosecrans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#img114_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brigadier General John Hunt Morgan and Martha “Mattie” Ready at the time of their wedding")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#img119_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon Creek Bridge as it looked after Morgan's command destroyed it on the Christmas Raid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#img121_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Woodcut of a Federal stockade protecting the Louisville and Nashville Railroad")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#img123_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colonel Basil W. Duke")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#img133_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An idealized portrait of Brigadier General John Hunt Morgan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#img134_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morgan's men ride toward the enemy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#img137_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brigadier General John Hunt Morgan from a photograph taken in late 1863 or early 1864")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#img143_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cavalrymen departing camp on a scout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#img148_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five officers from Morgan's command")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#img158_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A packet steamboat similar to the "), _c('i', [_vm._v("Hettie Gilmore")]), _vm._v(",  which was sunk by Captain Thomas Henry Hines")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#img160_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shaker community main residence building, South Union, Logan County, Kentucky")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#img162_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Locomotives in the railroad yards in Nashville, Tennessee")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#img169_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lebanon Junction, Kentucky, as it looked during the Civil War")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#img180_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prisoners of war at Fort Delaware, May 1864")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#img181_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johnson's Island Prisoner of War Depot, drawn by Joseph Mason Kern of the Thirteenth Virginia Infantry")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#img186_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A sketch of Johnson's Island Prisoner of War Depot showing the USS "), _c('i', [_vm._v("Michigan")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#img193_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ruins of Richmond, Virginia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#img197_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Uncle John Watson Porter of Madison, Georgia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#img198_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Railroad car shed, Atlanta, Georgia, destroyed by General William T. Sherman's troops")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#img200_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Train leaving the Chattanooga Railroad terminal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#img203_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Marion Porter, from a photograph taken in Bowling Green, Kentucky, after the war")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#img18_1"
    }
  }, [_vm._v("Butler, Logan, Warren, and Simpson Counties in Kentucky")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#img36_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Western Confederacy Collapses, Fall 1861 to Spring 1862")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#img64_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Kentucky Raid, July 1862")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#img91_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invasion of Kentucky, September 1862")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#img105_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Withdrawal from Kentucky, October 1862")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#img124_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Christmas Raid, December 1862-January 1863")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#img135_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morgan's Cavalry Division Protects Bragg's Right Flank, January- June 1863")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#img172_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great Raid, June-July 1863")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#img183_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johnson's Island Prisoner of War Depot, from a diagram drawn by John M. Porter showing his failed escape route")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#img201_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Porter's Travels Home, Spring 1865")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2be559de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/illu.vue
// module id = 75
// module chunks = 0